import { render } from "./QRCodeWidget.vue?vue&type=template&id=6cd237c4"
import script from "./QRCodeWidget.vue?vue&type=script&lang=js"
export * from "./QRCodeWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__